import { server } from '../server';
export const getAgentTiers = async (chainLayer, bondingToken) => {
    const queryParams = new URLSearchParams({
        bonding_token: bondingToken,
    });
    const response = await server.get({
        endpoint: 'tiers',
        queryParams,
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error fetching tiers: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
